import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PageDTO } from '../../../shared/page-dto';
import { PressroomDTO } from '../../../shared/pressroom-dto';

@Injectable({
  providedIn: 'root'
})
export class ArtistService {

  constructor(private http: HttpClient) { }

  getRoster(): Observable<{ active: any[], full: any[] }> {
    return this.http.get<{ active: any[], full: any[] }>(`/api/artist/roster`);
  }

  getArtistDetail(url_alias: string): Observable<PageDTO> {
    return this.http.get<PageDTO>(`/api/artist/${url_alias}`)
  }

  getArtistPressroom(url_alias: string): Observable<PressroomDTO> {
    return this.http.get<PressroomDTO>(`/api/artist/${url_alias}/pressroom`)
  }

  getPressArtists(): Observable<{ url_alias: string, id: number, name: string}[]> {
    return this.http.get<{ url_alias: string, id: number, name: string}[]>(`/api/artist/pressroom`)
  }

  downloadBlob(url: string): Observable<Blob> {
    return this.http.get(url, { responseType: "blob" as "blob" })
  }

  getArtistStoreList(): Observable<{ id: number, name: string, url_alias: string, status: string }[]> {
    return this.http.get(`/api/artist/artistList/`) as Observable<any>;
  }
}
